<template>
<div class="chapter">
<div class="inner_page">
<p class="p10"><span class="sz"><b>Dedication</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p11"><span class="sz"><i>To Barney…</i></span></p>
<p class="p3"><span class="sz"><i>Thanks for the hot meals when we would have had cold cuts the days I was glued to the computer!</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?1216e65c